"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.axiosTryCatchWrapper = void 0;
const isAxiosError = (error) => !!error && typeof error === 'object' && error.isAxiosError;
const axiosTryCatchWrapper = async (axiosFunctionToExecute, defaultErrorMessage = 'Internal Server Error') => {
    try {
        return await axiosFunctionToExecute();
    }
    catch (error) {
        if (isAxiosError(error)) {
            if (error.response) {
                const { data, status } = error.response;
                throw new Error(JSON.stringify({ data, status }));
            }
            if (error.request) {
                const { data, status } = error.request;
                throw new Error(JSON.stringify({ data, status }));
            }
        }
        if (error instanceof Error) {
            throw new Error(error.message);
        }
        if (typeof error === 'string') {
            throw new Error(error);
        }
        throw new Error(defaultErrorMessage);
    }
};
exports.axiosTryCatchWrapper = axiosTryCatchWrapper;
